// extracted by mini-css-extract-plugin
export default {"backLink":"RecoveryLogin_backLink__jbBun","description":"RecoveryLogin_description__W76lr","resendBtn":"RecoveryLogin_resendBtn__torHb"};